


















































import { Component, Vue, PropSync } from "vue-property-decorator";

@Component
export default class ContatoLocal extends Vue {
  @PropSync("veiculoDoAssociado")
  veiculoDoAssociadoSynced!: boolean;
  @PropSync("nomeContatoNoLocal")
  nomeContatoNoLocalSynced!: string;
  @PropSync("telefoneContatoNoLocal")
  telefoneContatoNoLocalSynced!: string;

  mounted() {
    // usuarioModule.updateUsuario().then(() => {
    //   const user = usuarioModule.usuario;
    //   if (user) {
    //     const isCompany = user.cpfCnpj.length > 11;
    //     if (isCompany) {
    //       CadastroModule.obterCadastroClientePJ(
    //         user.idCliente
    //       ).then(() => {
    //         const client = CadastroModule.dadosBasicosPessoaJuridicaModel;
    //         // this.nomeContatoNoLocalSynced = client.dadosBasicosPessoaJuridicaModel.
    //         this.telefoneContatoNoLocalSynced = client?.telefones[0].numero ?? '';
    //       });
    //     } else {
    //       CadastroModule.obterCadastroClientePF(
    //         user.idCliente
    //       ).then(() => {
    //         const client = CadastroModule.dadosBasicosPessoaFisica;
    //         this.nomeContatoNoLocalSynced = client?.nome ?? '';
    //         this.telefoneContatoNoLocalSynced = client?.telefones[0]?.numero ?? '';
    //       });
    //     }
    //   }
    // });
  }
}
